"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _systemConstants = require("@telus-uds/system-constants");
var _componentsBase = require("@telus-uds/components-base");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _videoPropType = require("./videoPropType");
var _VideoPickerThumbnail = _interopRequireDefault(require("./VideoPickerThumbnail"));
var _VideoPickerPlayer = _interopRequireDefault(require("./VideoPickerPlayer"));
var _VideoSlider = _interopRequireDefault(require("./VideoSlider"));
var _utils = require("../utils");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const [selectProps, selectedSystemPropTypes] = (0, _componentsBase.selectSystemProps)([_utils.htmlAttrs]);
const framedContainerStyles = _ref => {
  let {
    framedContainerBackgroundColor,
    framedContainerBorderWidth,
    framedContainerBorderColor,
    framedContainerBorderRadius,
    framedMaxHeight
  } = _ref;
  return (0, _styledComponents.css)(["background-color:", ";border:", "px solid ", ";border-radius:", "px;& > div{max-height:", "px;}"], framedContainerBackgroundColor, framedContainerBorderWidth, framedContainerBorderColor, framedContainerBorderRadius, framedMaxHeight);
};
const VideoPickerContainer = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "VideoPicker__VideoPickerContainer",
  componentId: "components-web__sc-x6lxp0-0"
})(["", ""], _ref2 => {
  let {
    isFramed,
    ...tokens
  } = _ref2;
  return isFramed && framedContainerStyles(tokens);
});
const framedPlayerContainerStyles = _ref3 => {
  let {
    framedMaxHeight,
    framedContainerPadding
  } = _ref3;
  return (0, _styledComponents.css)(["width:66.67%;padding:", "px;max-height:", "px;flex-shrink:0;box-sizing:border-box;"], framedContainerPadding, framedMaxHeight);
};
const VideoPlayerContainer = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "VideoPicker__VideoPlayerContainer",
  componentId: "components-web__sc-x6lxp0-1"
})(["", " overflow:auto;"], _ref4 => {
  let {
    isFramed,
    ...tokens
  } = _ref4;
  return isFramed && framedPlayerContainerStyles(tokens);
});
const framedVideoListContainerStyle = /*#__PURE__*/(0, _styledComponents.css)(["max-height:", "px;overflow:auto;flex-direction:column;"], _ref5 => {
  let {
    framedMaxHeight
  } = _ref5;
  return framedMaxHeight;
});
const VideoListContainer = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "VideoPicker__VideoListContainer",
  componentId: "components-web__sc-x6lxp0-2"
})(["display:flex;justify-content:flex-start;position:relative;flex-grow:1;flex-direction:column;", ""], props => props.isFramed && framedVideoListContainerStyle);
const VideoPicker = /*#__PURE__*/_react.default.forwardRef((_ref6, ref) => {
  let {
    videoList = [],
    selectedVideo = videoList[0]?.videoId,
    frame,
    onStartVideo = () => {},
    onSelectVideo = () => {},
    onPlay = () => {},
    onPause = () => {},
    onProgress = () => {},
    ...rest
  } = _ref6;
  const viewport = (0, _componentsBase.useViewport)();
  const {
    stackViewDividerColor,
    ...themeTokens
  } = (0, _componentsBase.useThemeTokens)('VideoPicker');
  const [currentVideoId, setCurrentVideoId] = _react.default.useState(selectedVideo);
  const videoPlayerRef = _react.default.useRef(null);
  const currentVideo = videoList.find(video => video.videoId === currentVideoId);
  _react.default.useEffect(() => {
    // Update current video if parent changes which video id it passes down
    setCurrentVideoId(selectedVideo);
  }, [selectedVideo]);
  const addVideoEventHandlers = video => {
    if (!video) return {};
    return {
      ...video,
      onPlay: video.onPlay || onPlay,
      onPause: video.onPause || onPause,
      onProgress: video.onProgress || onProgress
    };
  };

  // `frame` variant should only work on larger screens
  const isFramed = frame && [_systemConstants.viewports.lg, _systemConstants.viewports.xl].includes(viewport);
  const hasSlider = !frame && [_systemConstants.viewports.md, _systemConstants.viewports.lg, _systemConstants.viewports.xl].includes(viewport);
  const listElements = videoList.map((video, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_VideoPickerThumbnail.default, {
    video: video,
    videoPlayerRef: videoPlayerRef,
    selectedVideoId: currentVideoId,
    onSelectVideo: current => {
      setCurrentVideoId(current.videoId);
      onSelectVideo(current);
    },
    layout: !hasSlider ? 'horizontal' : 'vertical',
    index: index,
    isFramed: isFramed
  }, video.videoId));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(VideoPickerContainer, {
    ref: ref,
    isFramed: isFramed,
    ...selectProps(rest),
    ...themeTokens,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_componentsBase.StackView, {
      divider: isFramed ? {
        tokens: {
          color: stackViewDividerColor
        }
      } : {
        variant: {
          decorative: true
        }
      },
      space: isFramed ? 0 : 4 // everything has internal padding in `frame` variant
      ,
      direction: isFramed ? 'row' : 'column',
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(VideoPlayerContainer, {
        ...themeTokens,
        isFramed: isFramed,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_VideoPickerPlayer.default, {
          video: addVideoEventHandlers(currentVideo),
          videoPlayerRef: videoPlayerRef,
          onStartVideo: onStartVideo
        })
      }), hasSlider ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_VideoSlider.default, {
        children: listElements
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(VideoListContainer, {
        viewport: viewport,
        "data-testid": "video-list-container",
        isFramed: isFramed,
        children: listElements
      })]
    })
  });
});
VideoPicker.displayName = 'VideoPicker';
VideoPicker.propTypes = {
  ...selectedSystemPropTypes,
  tokens: (0, _componentsBase.getTokensPropType)('VideoPicker'),
  /**
   * Id of the currently selected video (defaults to the first video if not set).
   */
  selectedVideo: _propTypes.default.string,
  /**
   * An array of Video objects.
   */
  videoList: _propTypes.default.arrayOf(_videoPropType.VideoPropType),
  /**
   * Use to display the picker in a container and the playlist as a sidebar (only available for breakpoints LG and larger)
   */
  frame: _propTypes.default.bool,
  /**
   * Callback function trigerred when the video player starts playing video.
   * @param {object} video - The video object that is playing.
   */
  onStartVideo: _propTypes.default.func,
  /**
   * Callback function trigerred when a video is selected from the thumbnail list.
   * @param {object} video - The video object that is selected.
   */
  onSelectVideo: _propTypes.default.func,
  /**
   * Callback function trigerred during progress milestones 10% 25% 50% 75% 100%.
   * @param {object} event - The event object.
   */
  onProgress: _propTypes.default.func,
  /**
   * Callback function trigerred when the video player starts playing video.
   * @param {object} event - The event object.
   */
  onPlay: _propTypes.default.func,
  /**
   * Callback function trigerred when the video gets paused.
   * @param {object} event - The event object.
   */
  onPause: _propTypes.default.func
};
var _default = exports.default = VideoPicker;